// @ts-check

import { injectStyle } from './shared/utils';
import { injectFavicon, injectScript, setTitle } from './shared/utils/dom';
import { agencyTheme } from './shared/themes/agency';
import { Product } from './shared/utils/product';
import { useEnv } from './shared/utils/env';

const injectStaticAssets = (theme) => {
  if (theme.css) injectStyle(theme.css);
  injectFavicon(theme.favicon);
};

export default {
  /**
   * C360 Plugin install function.
   * @param {import('vue').VueConstructor} Vue
   * @param {{ product: string, theme: import('./shared/themes').C360Theme }} options
   */
  install(
    Vue,
    { product, theme = agencyTheme } = { product: Product.MediaPlanner, theme: agencyTheme },
  ) {
    injectStaticAssets(theme);
    const env = useEnv({ shortened: true });
    injectScript(true, `https://c360-wc-static-${env}.s3.amazonaws.com/esm/c360.js`);
    injectStyle(`https://c360-wc-static-${env}.s3.amazonaws.com/c360/c360.css`);
    Vue.prototype.$c360 = { ...theme, product };
    return setTitle(theme.portalName, product);
  },
};
